module.exports = __webpack_public_path__ + "static/media/img-imobiliarias-pag.1b7dec24.jpg";